export default __webpack_public_path__ + "static/media/p3c3-bg.46c80250.png";